import { datadogLogs } from '@datadog/browser-logs';

const clearContact = (contact: connect.Contact): void => {
  contact.clear({
    success: function () {},
    failure: function (error) {
      datadogLogs.logger.error(`Failed to clear the contact: ${error}`);
    }
  });
};

//TODO: Make the success and failure callbacks required
export const endConversation = (contact: connect.Contact, onSuccess?: () => void, onError?: () => void): void => {
  const callbacks = {
    success: () => {
      onSuccess?.();
    },
    failure: (error: unknown) => {
      datadogLogs.logger.error(`Failed to close the conversation: ${String(error)}`);
      onError?.();
    }
  };

  if (contact.isConnected()) {
    contact.getAgentConnection().destroy(callbacks);
  } else {
    clearContact(contact);
    onSuccess?.();
  }
};

export const endAndCloseConversation = (contact: connect.Contact, onError?: () => void): void => {
  contact.getAgentConnection().destroy({
    success: function () {
      clearContact(contact);
    },
    failure: function (error) {
      datadogLogs.logger.error(`Failed to close the conversation: ${error}`);
      onError?.();
    }
  });
};
